/**
 * RecoveryPills — compact "Recovery at a Glance" strip.
 * Replaces verbose multi-row aftercare timelines.
 * Shows 3–5 colored pill badges in a single row.
 */

interface Pill {
  label: string;   // e.g. "Day 1–3"
  note: string;    // e.g. "Mild redness, SPF only"
  color?: string;  // optional accent override
}

interface RecoveryPillsProps {
  pills: Pill[];
  /** Optional expandable detail text shown below the pills */
  detail?: string;
}

const PILL_COLORS = ["#5B7A9E", "#4A6A8E", "#a06050", "#7a4a3a", "#5a3428"];

export default function RecoveryPills({ pills, detail }: RecoveryPillsProps) {
  return (
    <div style={{ marginTop: "1rem" }}>
      {/* Pill strip */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "0.5rem",
          alignItems: "flex-start",
        }}
      >
        {pills.map((pill, i) => (
          <div
            key={i}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 4,
              flex: "1 1 auto",
              minWidth: 80,
              maxWidth: 160,
            }}
          >
            {/* Colored label badge */}
            <div
              style={{
                background: pill.color ?? PILL_COLORS[i % PILL_COLORS.length],
                color: "#fff",
                fontFamily: "'Lato',sans-serif",
                fontSize: "0.65rem",
                fontWeight: 800,
                letterSpacing: "0.1em",
                textTransform: "uppercase",
                padding: "0.3rem 0.7rem",
                borderRadius: 20,
                whiteSpace: "nowrap",
              }}
            >
              {pill.label}
            </div>
            {/* Note */}
            <div
              style={{
                fontFamily: "'Lato',sans-serif",
                fontSize: "0.72rem",
                color: "#4a5a50",
                textAlign: "center",
                lineHeight: 1.35,
              }}
            >
              {pill.note}
            </div>
          </div>
        ))}
      </div>

      {/* Optional detail line */}
      {detail && (
        <p
          style={{
            fontFamily: "'Lato',sans-serif",
            fontSize: "0.78rem",
            color: "#6b7c72",
            marginTop: "0.75rem",
            fontStyle: "italic",
          }}
        >
          {detail}
        </p>
      )}
    </div>
  );
}
